// UN ERROR QUE NO ES DE NADIE, Y HAY QUE CALLARLO ANTES DE QUE ASUSTE.
//
// Alguna extension de navegador intenta clonar un `PerformanceServerTiming` para mandarselo a
// si misma y falla con `DataCloneError`. No es de la Academia, no rompe nada y no se puede
// arreglar desde aqui; lo unico que hace es pintar un error rojo en la consola que despues hay
// que descartar cada vez que se busca uno de verdad. Un log lleno de ruido es un log que no se
// mira.
//
// VIVIA EN UN `<script>` DENTRO DE `public/index.html`, y era el UNICO script en linea de toda
// la plataforma. Eso solo no molestaba a nadie, pero obligaba a que la Content-Security-Policy
// aceptara scripts en linea -con `unsafe-inline` o con un hash que hay que recalcular a mano
// cada vez que se toca una letra-, o sea que la cabecera mas valiosa de todas quedaba rebajada
// por seis lineas de ruido. Aqui es un fichero mas del paquete y la politica puede decir
// `script-src 'self'` a secas. Lo vigila `tools/check_csp.py`.
//
// Se llama desde `index.js` antes de montar React, que es lo mismo que hacia estando en el
// `<head>`: lo que importa es que el oyente este puesto antes de que llegue el error.

export function callaElRuidoDeLasExtensiones() {
  if (typeof window === "undefined") return;
  window.addEventListener("error", (e) => {
    const esOtro = e.error instanceof DOMException
      && e.error.name === "DataCloneError"
      && e.message
      && e.message.includes("PerformanceServerTiming");
    if (esOtro) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
}
